let Constants = {

  //--Synchronization status
  STATUS_SYNCHRONIZATION_SUCCESS : 'success',
  STATUS_SYNCHRONIZATION_FAILED  : 'failure',

  //--Synchronization errors
  ERROR_INVALID_TOKEN             : 0x0BD01,
  ERROR_DEVICE_UNKNOWN            : 0x0BD02,
  ERROR_DEVICE_UNAVAILABLE        : 0x0BD02,
  ERROR_DEVICE_NOT_ACTIVATED      : 0x0BD03,
  ERROR_DEVICE_OUTDATED_ACTIVATION: 0x0BD04,
  ERROR_DEVICE_SUBSCRIPTION_ENDED : 0x0BD05
};

Constants.getPartialSynchronizationCauseMessage = (code) => {
  switch(code) {
    case Constants.CAUSE_OUDATED_MAINTENANCE_DUE_DATE:
      return 'Contrat de maintenance expiré';
    default:
      return `CAUSE_${code}`;
  }
}

Constants.getErrorMessage = (code) => {

  switch(code) {
    case Constants.ERROR_INVALID_TOKEN:
      return `Jeton d'accès invalide`;
    case Constants.ERROR_DEVICE_UNAVAILABLE:
      return 'Non disponible';
    case Constants.ERROR_DEVICE_NOT_ACTIVATED:
      return 'Non activé';
    case Constants.ERROR_DEVICE_OUTDATED_ACTIVATION:
      return 'Ancienne activation';
    case Constants.ERROR_DEVICE_SUBSCRIPTION_ENDED:
      return `Date limite d'abonnement expirée`;
    default:
      return `ERROR_${code}`;
  }

};

Constants.getExpirationMessage = (days) => {

  if (days > 0) {
    let message;

    if (days === 1) {
      message = "demain";
    } else {
      message = `dans ${days} jours`;
    }

    return `Expire ${message}`;

  } else {

    let message;

    if (days === 0) {
      message = "aujourd'hui";
    } else if (days === -1) {
      message = "hier";
    } else {
      message = `${Math.abs(days)} jours`;
    }

    return `Expiré depuis ${message}`;
  }
};

Constants.getActivationCode = (code) => {
  return `${code.slice(0, 4)}-${code.slice(4, 8)}-${code.slice(8, 12)}`;
};

export default Object.seal(Constants);
